//分配用户， 这里用来管理用户给自己下级分配字账户
import { UserGrantType } from "./UserType";
import { Modal } from '../../components'
import { useEffect, useState } from "react";
import {Alert, Tag,message, Select
} from 'antd';
import { useTranslation } from "../../hooks/useTranslation";
import { useSelector } from "../../hooks/useSelector";
import { useRequest } from "../../hooks/useRequest";
import { api } from "../../config/api";

export const GrantUser: React.FC<UserGrantType> = ({id, onClose}) => {
    // const [parentId1, setParentId1] = useState(parentId || 0);
    const [enable, setEnable] = useState(true);
    const t = useTranslation();
    const setting = useSelector(state => state.setting);
    const {json} = useRequest();

    const [users, setUsers] = useState<any[]>([]);
    const [toggledUsers, setToggledUsers] = useState<any[]>([]);

    const getUsers = async (id, type) => {
        let result = await json.get(api.user.toggle+"?id="+id);
        if(result.status){
            if(type==1){
                setUsers(result.data);
            }else{
                setToggledUsers(result.data);
            }
        } 
    }

    useEffect(()=>{
        getUsers(0, 1);
        getUsers(id, 2);
    }, 
    // eslint-disable-next-line
    []);
    

    const handleCancel = () => {
        setEnable(false);
        if(onClose){
            setTimeout(() => {
                onClose(false);
            }, 500);
        }
    }

    const removeUser = (e, key) => {
        e.preventDefault();
        setToggledUsers(toggledUsers.filter(u => u.key != key));
    };

    const addUser = (key) => {
        let idx = toggledUsers.findIndex(u => u.key == key);
        // console.log(key, idx);
        if(idx==-1){
            let temp = users.find(u => u.key == key);
            if(temp){
                setToggledUsers(us => [...us, temp]);
            }
        }
    }

    const submit = () => {
        let param = {
            id: id,
            users: toggledUsers.map(u => u.key).join(",")
        }
        
        let update = async() => {
            let result = await json.post(api.user.update, param);
            message.success(t(result.msg));
            if(result.status){
                handleCancel();
            }
        }

        update();
    }

    const formHtml = (
        <div className="edit-form-wrap">
            <Alert message={t("分配后，该用户可以管理分配的用户的数据")} type="warning" showIcon closable />
            <div className="owner-users">
                {toggledUsers.map(u => {return (
                        <Tag key={u.key} closable onClose={(e) => removeUser(e, u.key)}>{"("+u.key+")"+u.label}</Tag>
                    )})
                }
            </div>
            <Select allowClear size={setting.size} style={{minWidth: "400px"}} onChange={addUser}>
                {users.map(i => (
                    <Select.Option value={i.id} key={i.id} >
                        {i.key+"-"+i.label}
                    </Select.Option>
                ))}
            </Select>
        </div>
    );

    let title =t('分配用户')
        
    return (
        <Modal visible={enable}
            title={title}
            width={500}
            onOk={()=>{submit()}}
            onCancel={()=>handleCancel()}
            afterClose={()=>handleCancel()}
        >
            {formHtml}
        </Modal>
    )
}